import type zh from "./zh";

const en: typeof zh = {
  "site.title": "Tee Break Notes",
  "header.blog": "Blog",
  "header.resume": "Resume",
  "footer.builtWith": "Built with",
  "footer.createdBy": "Created by Felix",
  "home.latestPosts": "Latest Posts",
  "home.more": "More >>",
  "home.headTitle": "Home",
  "blogList.headTitle": "Blog List",
  "notFound.title": "NOT FOUND",
  "notFound.message":
    "You just hit a route that doesn't exist... the sadness.",
  "notFound.headTitle": "404: Not found",
  "cc.text": "This work is licensed under a ",
  "cc.licenseName":
    "Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License",
  "cc.suffix":
    ". When redistributing, please cite the original link. When using images, please retain all content. Do not modify this work, create derivative works, or use it for commercial purposes.",
  "lang.label": "EN",
};

export default en;
